import axios from 'axios'
import { ExportVideoIds, ExportVideoParams, ExportVideo, ExportVideosResponse } from '../interfaces/export'

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
})

export async function fetchExportVideos(ids: ExportVideoIds) {
  const response = await HTTP.get(`/export-analysis-video/?project=${ids.project}&stimulus=${ids.stimulus}`)
  return response.data as ExportVideosResponse
}

export async function createExportVideo(payload: ExportVideoParams) {
  const response = await HTTP.post('/create-analysis-export-video/', payload)
  return response.data as ExportVideo
}

export async function deleteExportVideo(uuid: string) {
  const response = await HTTP.delete(`export-analysis-video/${uuid}`)
  return response.status
}
